import { z } from "zod";
const declaration = {
    sourceId: z.string().uuid(),
    hostname: z
        .string()
        .min(3)
        .max(253)
        .regex(/^[a-z0-9.-]+$/),
    legalName: z.string().trim().min(2).max(200),
    cnpj: z.string().regex(/^\d{14}$/),
    registrationKind: z.enum(["OPERATOR_REVIEW", "AUTHORIZED_AUTOMATION"]),
    sourceReference: z.string().trim().min(10).max(2000),
    identityEvidenceIds: z.array(z.string().uuid()).min(1).max(16),
    validFrom: z.string().date(),
    validTo: z.string().date().nullable(),
};
const validDeclaration = (value) => (value.validTo === null || value.validTo >= value.validFrom) &&
    new Set(value.identityEvidenceIds).size === value.identityEvidenceIds.length;
/** An attributable ADMIN association, never product verification or fiscal approval. */
export const applianceManufacturerIdentityCreateSchema = z
    .object(declaration)
    .strict()
    .refine(validDeclaration, "Evidence references must be distinct and the date window valid");
export const applianceManufacturerIdentityRecordSchema = z
    .object({
    ...declaration,
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    supplierId: z.string().uuid(),
    status: z.literal("DECLARED"),
    registeredBy: z.string().uuid(),
    createdAt: z.string().datetime(),
    registrationSha256: z.string().regex(/^[a-f0-9]{64}$/),
})
    .strict()
    .refine(validDeclaration);
export const applianceManufacturerIdentityListSchema = z
    .object({ items: z.array(applianceManufacturerIdentityRecordSchema).max(1000) })
    .strict();
//# sourceMappingURL=appliance-manufacturer-identities.js.map